import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function ScrollToTop(args) {
  const history = useHistory();

  useEffect(() => {
    let previousLocation = history.location;

    return history.listen((nextLocation, action) => {
      const leftLocation = previousLocation;
      previousLocation = nextLocation;

      if (nextLocation.state?.disableScrollToTop) {
        return; // Skip scrolling if disableScrollToTop is true in the state
      }

      if (action === 'POP' && leftLocation.state?.disableScrollToTop) {
        return; // Going back out of a location that kept the scroll returns to the same place
      }

      if (document.documentElement.classList?.contains('disable-scroll-to-top')) {
        return; // Skip scrolling if the class is present
      }

      window.scrollTo(0, 0);
    });
  }, [history]);

  return <React.Fragment {...args} />;
}

export default ScrollToTop;
